// extracted by mini-css-extract-plugin
export default {"passwordFormContent":"hESr2r6A"};